import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'
import StringHelpers from '../helpers/StringHelpers'
import DataHelpers from './DataHelpers'
import AlertHelpers from './AlertHelpers'
import {format} from 'date-fns'
import Vue from 'vue'


export default class {

static fileToDataUrl(file) {
    return new Promise( (resolve, reject) => {
        const fileReader = new FileReader
        fileReader.addEventListener('load', () => {
            resolve(fileReader.result)
        })
        fileReader.readAsDataURL(file) 
    })
}

static storeFiles(browserFiles, path, startCallback, statusCallback, finishCallback) {
    const uploadList = browserFiles.map(file => {
        return {
            _file: file,
            name: this.transformFilename(file.name),
            size: file.size,
            type: file.type,
            lastModified: file.lastModifiedDate,
            progress: 0,
        }
    })

    startCallback(uploadList)

    uploadList.forEach(upload => {
        const fileObj = upload._file
        delete upload._file
        this.fileToFirebase(fileObj, `${path}/${upload.name}`, function(progress) {
            upload.progress = progress
        }).then((url) => {
            upload.url = url
            if(this.finishedUploading(uploadList))
                finishCallback(uploadList)
        })
    })

}

static finishedUploading(list) {
    const inProgress = list.find((o => !o.url))
    return !Boolean(inProgress)
}

static filesToFirebase(files, path) {
    return new Promise( (resolve, reject) => {
        let uploadCount = 0
        let fileGroup = []
        for(var n = 0; n < files.length; n++) {
            let file = files[n]
    
            if(file.size > 7500000) {
                AlertHelpers.showAlert('File size is too big:' + file.name)
                uploadCount ++
                if(uploadCount == files.length) 
                    resolve(fileGroup)
                continue // skips this iteration only
            }
            
            console.log('Uploading ' + file.name)

            // let randomKey = DataHelpers.getKey()
            // let fileName = file.name.replace(/\./, randomKey + '.')
            let fileName = this.transformFilename(file.name)
    
            this.fileToFirebase(file, `${path}/${fileName}`).then((url) => {
                fileGroup.push({
                    url,
                    size: file.size,
                    originalName: file.name,
                })
                uploadCount ++
                if(uploadCount == files.length) 
                    resolve(fileGroup)
            })
        }                
    
    })
}

static fileToFirebase(file, path, statusCallback) {
    return new Promise( (resolve, reject) => {
        const uploadTask = firebase.storage().ref(path).put(file)

        //New way that does percentages...

        uploadTask.on('state_changed', function(snapshot){
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            if(statusCallback) {
                //console.log ('setting progress to ', progress)
                statusCallback(Math.round(progress))
            }
        }, function(err) {

        }, function() {
            uploadTask.snapshot.ref.getDownloadURL().then(url => {
                resolve(url)
            })
        })

    })
}

static removeFileExtension(fileName) {
    const arr =  fileName.split('.')
    if( arr.length > 1)
        arr.pop()
    return arr.join('.')
}

static getFileExtension(fileName) {
    const arr = fileName.split('.')
    if(arr.length < 2)
        return ''
    return arr[arr.length - 1]
}

static transformFilename(fileName) {
    let result = this.removeFileExtension(fileName)
    result = result.replace(/\W/gi, '-')
    result = result.substring(0, 16)
    // result = result + '-' + format(new Date(), 'MMMd')
    result = result + '-' + StringHelpers.randomString(6)
    result = result + '.' + this.getFileExtension(fileName)
    return result.toLowerCase()
}

static cleanFilename(fileName) {
    let result = this.removeFileExtension(fileName)
    result = result.replace(/[^a-zA-Z\d\s:]/g, ' ')
    result = StringHelpers.toTitleCase(result)
    return result
}

static fileNameFromStoragePath(path) {
    
    if(!path)
        return ''

    //inject slashes then take everything after the last slash and before the question mark, and then reinsert spaces
    return path.replace(/\%2F/g, '/').split('/').slice(-1).pop().split('?')[0].replace(/\%20/g, ' ')
}

static deleteFirebaseFile(url) {
    let ref = firebase.storage().refFromURL(url)
    ref.delete()
}

static downloadObject(exportObj, exportName){
    var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj))
    var downloadAnchorNode = document.createElement('a')
    downloadAnchorNode.setAttribute("href",     dataStr)
    downloadAnchorNode.setAttribute("download", exportName + ".json")
    document.body.appendChild(downloadAnchorNode) // required for firefox
    downloadAnchorNode.click()
    downloadAnchorNode.remove()
  }

}


// WEBPACK FOOTER //
// ./src/helpers/FileHelpers.js